import React from 'react';
import { FaDownload, FaFilePdf, FaFileWord, FaCalendarAlt, FaFileExcel, FaFileImage } from 'react-icons/fa';

const Downloads = () => {
  const downloads = [
    { name: "Prospectus 2024-25", type: "PDF", size: "2.5 MB", date: "March 2024", icon: FaFilePdf, color: "text-red-500" },
    { name: "Admission Form", type: "PDF", size: "1.2 MB", date: "March 2024", icon: FaFilePdf, color: "text-red-500" },
    { name: "Fee Structure", type: "PDF", size: "0.8 MB", date: "March 2024", icon: FaFilePdf, color: "text-red-500" },
    { name: "Academic Calendar 2024-25", type: "PDF", size: "1.1 MB", date: "January 2024", icon: FaFilePdf, color: "text-red-500" },
    { name: "Student Handbook", type: "PDF", size: "3.2 MB", date: "December 2023", icon: FaFilePdf, color: "text-red-500" },
    { name: "Scholarship Application Form", type: "Word", size: "0.5 MB", date: "February 2024", icon: FaFileWord, color: "text-blue-600" },
    { name: "Exam Schedule (Odd Semester)", type: "PDF", size: "0.9 MB", date: "November 2023", icon: FaFilePdf, color: "text-red-500" },
    { name: "Placement Brochure", type: "PDF", size: "1.8 MB", date: "October 2023", icon: FaFilePdf, color: "text-red-500" },
    { name: "Sports Registration Form", type: "Excel", size: "0.3 MB", date: "August 2023", icon: FaFileExcel, color: "text-green-500" },
    { name: "College ID Card Format", type: "Image", size: "0.2 MB", date: "July 2023", icon: FaFileImage, color: "text-blue-300" }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-blue-50/30">
      <div className="bg-gradient-to-r from-blue-700 to-indigo-700 py-20 text-center text-white">
        <h1 className="text-4xl md:text-5xl font-bold mb-4">Downloads</h1>
        <div className="w-20 h-1 bg-yellow-400 mx-auto rounded-full mb-4"></div>
        <p className="text-lg max-w-2xl mx-auto">Access important documents and forms</p>
      </div>

      <div className="container mx-auto px-6 py-16">
        <div className="bg-white rounded-2xl shadow-md overflow-hidden">
          <div className="hidden md:grid md:grid-cols-5 bg-gray-50 px-6 py-3 border-b font-semibold text-gray-700">
            <div className="col-span-2">Document Name</div><div>Type</div><div>Size</div><div>Date</div><div></div>
          </div>
          {downloads.map((item, idx) => (
            <div key={idx} className="grid md:grid-cols-5 items-center gap-3 p-4 border-b hover:bg-gray-50 transition">
              <div className="md:col-span-2 flex items-center gap-3">
                <item.icon className={`text-xl ${item.color}`} />
                <span className="font-medium text-gray-800">{item.name}</span>
              </div>
              <div><span className="px-2 py-1 bg-gray-100 rounded text-xs">{item.type}</span></div>
              <div className="text-gray-500 text-sm">{item.size}</div>
              <div className="text-gray-500 text-sm flex items-center gap-1"><FaCalendarAlt className="text-xs" /> {item.date}</div>
              <div><button className="text-blue-600 hover:text-blue-700 flex items-center gap-1 text-sm"><FaDownload /> Download</button></div>
            </div>
          ))}
        </div>
        <p className="text-center text-gray-500 text-sm mt-6">All documents are in PDF/Word format. Adobe Reader required for PDFs.</p>
      </div>
    </div>
  );
};

export default Downloads;